import { InjectableClass } from '@fino/lib-injection';

const iconSpriteElement = 'icon-sprite';

export class IconService extends InjectableClass {
  constructor($compile) {
    'ngInject';
    super({ $compile });
  }

  init($scope) {
    if (this.initialized) {
      return;
    }
    this.renderSprite($scope);
  }

  renderSprite($scope) {
    const { $compile } = this;
    var sprite = angular.element(document.createElement(iconSpriteElement));
    var el = $compile(sprite)($scope);
    angular.element(document.body).append(el);
    this.initialized = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-icon/src/icon.service.js